import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import ColorPicker from '../../../components/common/ColorPicker';
import {IPresentationTheme} from '../../../../incase-domain/presentationTheme';
import Label from '../../../../incase-domain/components/label/Label';
import Button from '../../../../incase-domain/components/button/Button';

interface PresentationThemeFavoriteColorsProps {
    favoriteColorsList: string[] | undefined;
    setPresentationTheme: (theme: IPresentationTheme) => void;
    presentationTheme: IPresentationTheme;
}

function PresentationThemeFavoriteColors(props: PresentationThemeFavoriteColorsProps): JSX.Element {
    const {favoriteColorsList, setPresentationTheme, presentationTheme} = props;
    const {t} = useTranslation();

    const [newFavoriteColor, setNewFavoriteColor] = useState<string>('');

    return (
        <div className="u-mt-2">
            <>
                <div className="l-group__item u-flex u-h-between u-v-center">
                    <Label size="lg">{t('presentationThemesPage.favoriteColors.favoriteColorsList')}</Label>
                    <div className="u-flex u-v-center u-gap-1">
                        {favoriteColorsList &&
                            favoriteColorsList.map((colorCode, index) => {
                                const keyIndex = `color-${colorCode}-${index}-inner`;

                                return (
                                    <div
                                        key={keyIndex}
                                        className="u-flex u-gap-1 u-v-center"
                                        style={{padding: '0.0625rem 0.1875rem', border: '1px solid lightgray', borderRadius: '1000px'}}
                                    >
                                        <div
                                            key={`c-colorPicker-${index}`}
                                            className="c-colorPicker__color"
                                            style={{backgroundColor: colorCode}}
                                        />
                                        <Button
                                            trailing="ph:x"
                                            size="2xs"
                                            variant="ghost"
                                            square
                                            rounded
                                            onClick={() => {
                                                const indexOf = favoriteColorsList.indexOf(colorCode);
                                                favoriteColorsList.splice(indexOf, 1);
                                                setPresentationTheme({
                                                    ...presentationTheme,
                                                    favoriteColors: favoriteColorsList,
                                                });
                                            }}
                                        />
                                    </div>
                                );
                            })}
                        <div style={{marginLeft: '0.5em'}}>
                            <ColorPicker
                                color={newFavoriteColor}
                                onChange={(e) => {
                                    if (favoriteColorsList && favoriteColorsList?.length > 6) {
                                        toast.error(t('presentationThemesPage.favoriteColors.tooMany'));
                                        return;
                                    }
                                    if (e) favoriteColorsList?.push(e);
                                    setPresentationTheme({
                                        ...presentationTheme,
                                        favoriteColors: favoriteColorsList,
                                    });
                                    setNewFavoriteColor('');
                                }}
                                secondary
                                forPresentation={false}
                            />
                        </div>
                    </div>
                </div>
            </>
        </div>
    );
}

export default PresentationThemeFavoriteColors;
